import React from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import StatementContentPanel from 'components/feature/statement-content-panel/statement-content-panel-component';
import {
  initStatementContent,
  initLeftStatementContent,
  batchSelectElements,
  batchSelectElementsInSideBySideMode,
} from 'store/actions/statement-content-actions';
import { clearBatchSelectedElementsAction } from 'store/actions/action-creators';
import withURLRouter from 'withURLRouter';
import { ROUTE_CONSTANTS } from 'constants/util/route-constants';
import {
  clearSideBySideElementsMap,
  clearSelectedElementsContentPanel,
} from 'store/actions/action-creators';
import {
  TRAIL_BALANCE_MODE,
  AUTO_TIEOUT_COMPARE_MODE,
} from 'constants/feature/statement-content-constants';
import { handleOmniaTagAndMapElements } from 'store/actions/trial-balance/trial-balance-action';

const StatementContentPanelComponentHOC = (props) => {
  const { revisionId, statementId } = useParams();
  const {
    leftSelectedStatement,
    selectedStatement,
    leftSectionIdList,
    sectionIdList,
    sectionsCache,
    leftSectionsCache,
    leftSideBySideView,
    zoom,
    leftZoom,
    rightZoom,
    URLString,
    clearSideBySideElementsMap,
    batchSelectElementsInSideBySideMode,
    batchSelectElements,
    sideBySideViewMode,
    isSnapshotViewLoaded,
  } = props;

  const isSideBySideView = URLString.includes(ROUTE_CONSTANTS.SIDE_BY_SIDE);

  const isTrialBalanceView =
    isSideBySideView && sideBySideViewMode.viewMode === TRAIL_BALANCE_MODE;

  const isAutoTieoutRightView =
    sideBySideViewMode.viewMode === AUTO_TIEOUT_COMPARE_MODE &&
    !leftSideBySideView;

  return (
    <StatementContentPanel
      {...props}
      selectedStatement={
        leftSideBySideView ? leftSelectedStatement : selectedStatement
      }
      dragSelectElements={
        URLString.includes(ROUTE_CONSTANTS.SIDE_BY_SIDE) &&
        !isTrialBalanceView &&
        !isAutoTieoutRightView
          ? batchSelectElementsInSideBySideMode
          : batchSelectElements
      }
      isSideBySideView={isSideBySideView}
      isReportPreview={URLString.includes(ROUTE_CONSTANTS.REPORT_PREVIEW)}
      zoom={
        URLString.includes(ROUTE_CONSTANTS.SIDE_BY_SIDE)
          ? leftSideBySideView
            ? leftZoom
            : rightZoom
          : zoom
      }
      sectionIdList={leftSideBySideView ? leftSectionIdList : sectionIdList}
      sectionsCache={leftSideBySideView ? leftSectionsCache : sectionsCache}
      clearSideBySideElementsMap={clearSideBySideElementsMap}
      revisionId={revisionId}
      statementId={statementId}
      isSnapshotViewLoaded={isSnapshotViewLoaded}
    />
  );
};

const mapStateToProps = (
  {
    data: {
      statementContent: {
        sectionsCache: { cache },
        sectionIdList,
      },
      leftStatementContent,
      leftStatementContent: {
        leftSectionIdList,
        leftSectionsCache: { leftCache },
      },
      selectedProject: { id },
      selectedStatement,
      leftSelectedStatement,
      batchPanel: { batchElementList },
    },
    ui: {
      sourceStatementParams,
      sideBySideView: {
        sideBySideElementMap,
        sideBySideViewMode,
        autoTieout: { workFlowStatus, workpaperDetails },
        trialBalance: { isSnapshotViewLoaded },
      },
      statementPage: {
        modes: { selectMode },
        zoom,
        leftZoom,
        rightZoom,
        contentHighlightSelector,
      },
    },
  },
  ownProps,
) => ({
  sectionsCache: cache,
  leftSectionsCache: leftCache,
  leftStatementContent,
  sectionIdList,
  leftSectionIdList,
  urlParams: ownProps.urlParams,
  selectMode,
  zoom,
  leftZoom,
  rightZoom,
  contentHighlightSelector,
  selectedProject: id,
  selectedStatement,
  leftSelectedStatement,
  numberOfSourceElementSelected:
    sideBySideElementMap && sideBySideElementMap.sizeOfSourceMapping,
  numberOfTargetElementSelected:
    sideBySideElementMap && sideBySideElementMap.sizeOfTargetMapping,
  sideBySideViewMode,
  workFlowStatus,
  autoTieoutWPDetails: workpaperDetails,
  isSnapshotViewLoaded,
  batchElementList,
  sourceStatementParams,
});

const mapDispatchToProps = {
  initStatementContent,
  initLeftStatementContent,
  batchSelectElementsInSideBySideMode,
  batchSelectElements,
  clearSideBySideElementsMap,
  clearBatchSelectedElementsAction,
  clearSelectedElementsContentPanel,
  handleOmniaTagAndMapElements,
};

export default withURLRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(StatementContentPanelComponentHOC),
);
